import { isBrowser } from './is-browser.js';
export const decode = (valToDecode) => {
    try {
        return isBrowser() ? window.atob(valToDecode) : Buffer.from(valToDecode, 'base64').toString('ascii');
    }
    catch (err) {
        console.error('Could not decode input from Base64');
        console.error(valToDecode);
        return '';
    }
};
export const encode = (valToEncode) => {
    try {
        return isBrowser() ? window.btoa(valToEncode) : Buffer.from(valToEncode).toString('base64');
    }
    catch (err) {
        console.error('Could not encode value to Base64');
        console.error(valToEncode);
        return '';
    }
};
//# sourceMappingURL=base64.js.map